import { useState } from 'react'
import { Chip, Button } from '@material-ui/core'
import clsx from 'clsx'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { LoadingFeedback, MenuButton } from 'components'
import { OrganizationCompaniesForm, OrganizationCompanyRemoveDialog } from '..'

import useStyles from './styles'
import constants from 'constants/index'

const OrganizationCompaniesTable = ({
  organizationCompanies,
  organization,
  refresh,
  isCreate,
}) => {
  const [currentOrganizationCompany, setCurrentOrganizationCompany] = useState()
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const classes = useStyles()

  const { STATUS } = constants.organizationCompanies

  const handleRemove = (organizationCompany) => {
    setCurrentOrganizationCompany(organizationCompany)
    setOpenRemoveDialog(true)
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Table emptyMessage="Não há empresas vinculadas">
        <TableHead>
          <TableRow>
            {!isCreate && <TableCell width="20%">ID</TableCell>}
            <TableCell width="40%">Empresa</TableCell>
            <TableCell width="30%">Status</TableCell>
            <TableCell width="30%" align="right">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {organizationCompanies?.map((organizationCompany, index) => (
            <TableRow key={organizationCompany?.id || index} hover>
              {!isCreate && (
                <TableCell disableTooltip>{organizationCompany?.id}</TableCell>
              )}
              <TableCell>{organizationCompany?.company?.name}</TableCell>

              <TableCell disableTooltip>
                <Chip
                  className={clsx(classes.root, {
                    [classes.active]:
                      organizationCompany?.status === STATUS.ACTIVE || isCreate,
                    [classes.inactive]:
                      organizationCompany?.status === STATUS.INACTIVE,
                  })}
                  align="center"
                  size="small"
                  label={
                    organizationCompany?.status === STATUS.INACTIVE
                      ? 'Inativo'
                      : 'Ativo'
                  }
                />
              </TableCell>
              <TableCell disableTooltip align="right">
                <MenuButton>
                  <Button
                    onClick={() => handleRemove(organizationCompany)}
                    fullWidth
                    size="small"
                  >
                    Excluir
                  </Button>
                </MenuButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {currentOrganizationCompany?.id && (
        <>
          <OrganizationCompaniesForm
            setOpen={setOpenEditDialog}
            refresh={refresh}
            open={openEditDialog}
            organization={organization}
            setIsLoading={setIsLoading}
          />
          <OrganizationCompanyRemoveDialog
            currentOrganizationCompany={currentOrganizationCompany}
            organization={organization}
            open={openRemoveDialog}
            setOpen={setOpenRemoveDialog}
            refresh={refresh}
          />
        </>
      )}
    </>
  )
}

export default OrganizationCompaniesTable
